// terms.store.ts
import { create } from "zustand";
import { devtools } from "zustand/middleware";

export type TermsCode = "PRIVACY_POLICY" | "TERMS_OF_SERVICE";

export type TermsItem = {
  termsId: number;
  termsCode: TermsCode; // ✅ 이제 enum으로 고정
  termsType: string;
  termsTtl: string;
  termsCts: string;
  termsStatus: string;
  termsOrder: number;
  termsRequired: boolean;
  applyStrDatetime: string;
  applyEndDatetime: string;
};

export type TermsQuery = {
  termsType: string;
  termsStatus: string;

  termsCode: "" | TermsCode; // ✅ 검색용(전체 포함)

  applyStrDatetime: string;
  applyEndDatetime: string;
  page: number;
  size: number;
  order: string;
  _searchTick: number;
};

type TermsState = TermsQuery & {
  setQuery: (next: Partial<TermsQuery>) => void;
  reset: () => void;
  triggerSearch: () => void;
};

const isDev = process.env.NODE_ENV === "development";

const initialState: TermsQuery = {
  termsType: "",
  termsStatus: "",
  termsCode: "",

  applyStrDatetime: "",
  applyEndDatetime: "",
  page: 1,
  size: 10,
  order: "termsOrder,asc",
  _searchTick: 0,
};

export const useTermsStore = create<TermsState>()(
  devtools(
    (set) => ({
      ...initialState,

      setQuery: (next) => set((s) => ({ ...s, ...next }), false, "terms/setQuery"),

      triggerSearch: () =>
        set(
          (s) => ({ ...s, page: 1, _searchTick: s._searchTick + 1 }),
          false,
          "terms/triggerSearch"
        ),

      reset: () => set({ ...initialState }, false, "terms/reset"),
    }),
    { name: "terms-store", enabled: isDev }
  )
);
